// extracted by mini-css-extract-plugin
export var tag = "TagList-module--tag--d5e8f";
export var tagList = "TagList-module--tagList--47361";